import { View, Loading } from '@upstox/upstox-ui';
import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useRef } from 'react';
// modules
import { edisService } from 'modules/Edis';
// constants
import { EDIS_INTERVAL } from 'modules/Edis/constants';

const styles: CSSFunction = () => ({
  height: '100%',
  width: '100%',
  backgroundColor: 'rgba(0,0,0,0.8)',
  position: 'absolute',
  zIndex: 25,
});

function Loader() {
  const timeout = useRef<null | number>(null);

  const checkStatus = useCallback(() => {
    edisService.getAuthoriseEdisStatus();
  }, []);

  useEffect(() => {
    timeout.current = window.setInterval(checkStatus, EDIS_INTERVAL);

    return () => {
      if (timeout.current) {
        window.clearInterval(timeout.current);
      }
    };
  }, [checkStatus]);

  return (
    <View
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      css={styles}
    >
      <Loading color="text.3" />
    </View>
  );
}

export default observer(Loader);
